import { Controller } from 'stimulus';
import { BEFORE_CONNECT } from '../constants';

export default class extends Controller {
  static targets = ['template', 'table', 'row']

  newRow() {
    return this.templateTarget.content.children[0].cloneNode(true);
  }

  rowIds() {
    return this.rowTargets.map((element) => {
      const controller = this.controllerFromElement(element);
      return controller.id;
    });
  }

  nextId() {
    return Math.max(-1, ...this.rowIds()) + 1;
  }

  add(e) {
    e.preventDefault();
    const nextId = this.nextId();
    const row = this.newRow();
    this.tableTarget.appendChild(row);
    row.addEventListener(BEFORE_CONNECT, (event) => {
      const controller = this.controllerFromEvent(event);
      controller.fix(nextId);
    });
  }

  controllerFromEvent(event) {
    return this.controllerFromElement(event.target);
  }

  controllerFromElement(element) {
    const controllerName = element.dataset.controller;
    return this.application.getControllerForElementAndIdentifier(element, controllerName);
  }
}
